import React from 'react';

const MatchHistoryConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/upload/matchhistory',
            component: React.lazy(() => import('./MatchHistory'))
        },
        /* Added the following code for POW-890.Solomon using AI Agent. July 16, 2026. Code Start */
        /**
         * Job-Resume Match History — same MatchHistory UI filtered by sourceType=RESUME_JOB_MATCH.
         */
        {
            path: '/upload/job-resume-match-history',
            component: React.lazy(() => import('./MatchHistory'))
        }
        /* Code end. Solomon using AI Agent. July 16, 2026 */
    ]
};

export default MatchHistoryConfig;